module.exports = __webpack_public_path__ + "static/media/gray_03.4577a59a.jpg";